(function () {
  if (customElements.get('mern-room-film')) return;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  class MernRoomFilm extends HTMLElement {
    connectedCallback() {
      var self = this;
      var c0 = navigator.connection || {};
      var mob = window.matchMedia('(max-width: 860px)').matches;
      // Phones get 720p, slow connections 480p, desktop 1080p. Fallbacks follow in order.
      var max = (c0.saveData || /2g|3g/.test(c0.effectiveType || '')) ? 480 : (mob ? 720 : 1080);
      var pick = function (str) {
        var all = (str || '').split(' ').filter(Boolean).map(function (x) { var i = x.indexOf('|'); return { h: +x.slice(0, i), u: x.slice(i + 1) }; });
        // Liquid only lists the 1080p file; Shopify also keeps 720p and 480p copies on a fixed ladder.
        var ladder = { '7.2': ['4.5', '1.5'], '4.8': ['3.0', '1.2'] };
        all.slice().forEach(function (x) {
          var m = x.u.match(/HD-1080p-(\d\.\d)Mbps/); var r = m && ladder[m[1]];
          if (r) { all.push({ h: 720, u: x.u.replace(m[0], 'HD-720p-' + r[0] + 'Mbps') }); all.push({ h: 480, u: x.u.replace(m[0], 'SD-480p-' + r[1] + 'Mbps') }); }
        });
        var ok = all.filter(function (x) { return x.h <= max; }).sort(function (a, b) { return b.h - a.h; });
        var rest = all.filter(function (x) { return x.h > max; }).sort(function (a, b) { return a.h - b.h; });
        return ok.concat(rest).map(function (x) { return x.u; });
      };
      this.rooms = [].slice.call(this.querySelectorAll('.mrf__room')).map(function (t) {
        var d = t.dataset;
        return { t: pick(d.t), l: pick(d.l), p: mob ? (d.pm || d.p) : d.p, nav: d.nav, focus: (parseFloat(d.focus) || 50) / 100, html: t.innerHTML };
      });
      if (!this.rooms.length) return;
      this.vids = [].slice.call(this.querySelectorAll('.mrf__v'));
      this.front = 0; this.cur = 0; this.token = 0; this.focusNow = this.rooms[0].focus;
      this.cap = this.querySelector('.mrf__cap');
      this.black = this.querySelector('.mrf__black');
      this.end = this.querySelector('.mrf__end');
      this.foot = this.querySelector('.mrf__foot');
      this.count = this.querySelector('.mrf__count');
      this.dots = [].slice.call(this.querySelectorAll('.mrf__dot'));
      this.prev = this.querySelector('.mrf__prev');
      this.next = this.querySelector('.mrf__next');
      this.poster = this.querySelector('.mrf__poster');
      this.still = this.querySelector('.mrf__still');
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var mode = this.dataset.mode || 'auto';
      this.lite = mode === 'photos' || (mode === 'auto' && !!c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
      if (this.poster) this.poster.style.objectPosition = this.pos(this.focusNow) + ' 50%';

      this.dots.forEach(function (d) { d.addEventListener('click', function () { self.jump(+d.dataset.i); }); });
      this.next.addEventListener('click', function () {
        if (self.cur < self.rooms.length - 1) self.play(self.cur + 1);
        else { self.cap.classList.remove('is-on'); self.black.classList.add('is-on'); setTimeout(function () { self.openEnd(); }, 900); }
      });
      this.prev.addEventListener('click', function () { if (self.cur > 0) self.jump(self.cur - 1); });
      this.querySelector('.mrf__again').addEventListener('click', function () { self.play(0); });

      var go0 = function () { if (self.started) return; self.started = true; self.keep = self.cap.classList.contains('is-on'); self.play(0); };
      var start = function () {
        var idle = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(go0, { timeout: 1500 }); };
        if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
      };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) start(); }, { rootMargin: '200px' });
        this.io.observe(this);
      } else start();
      document.addEventListener('shopify:block:select', this.onSel = function (e) {
        var i = [].slice.call(self.querySelectorAll('.mrf__room')).indexOf(e.target);
        if (i > -1) self.jump(i);
      });
      window.addEventListener('resize', this.onResize = function () { self.vids.forEach(function (v) { v.style.transition = 'opacity .5s ease'; v.style.objectPosition = self.pos(self.focusNow) + ' 50%'; }); });
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onSel) document.removeEventListener('shopify:block:select', this.onSel);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    // On narrow screens the 16:9 film is cropped. Keep the room's subject (its focus point) in view.
    pos(c) {
      var r = this.clientWidth / Math.max(1, this.clientHeight), v = r / (16 / 9);
      if (v >= 1) return '50%';
      var p = (c - v / 2) / (1 - v);
      return (Math.max(0, Math.min(1, p)) * 100).toFixed(1) + '%';
    }
    // Preload one file at a time, only what the visitor is about to see.
    warm(u) {
      if (!u || this.lite) return; this.pre = this.pre || {}; if (this.pre[u]) return;
      var v = document.createElement('video'); v.preload = 'auto'; v.muted = true; v.src = u; this.pre[u] = v;
    }
    setCopy(i) {
      var r = this.rooms[i];
      // Room 1's text is already in the page (it shows before the film starts), so keep it.
      if (this.cap.dataset.i !== String(i)) this.cap.innerHTML = r.html;
      delete this.cap.dataset.i;
      this.count.textContent = pad(i + 1) + ' / ' + pad(this.rooms.length);
      this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      this.prev.disabled = i === 0;
      var n = this.rooms[i + 1];
      this.next.querySelector('b').textContent = n ? n.nav : '';
    }
    // from / to: focus at the first and last frame. A walk-in clip pans the crop between rooms.
    goLite() {
      if (this.lite) return;
      this.lite = true;
      this.vids.forEach(function (v) { v.pause(); v.removeAttribute('src'); v.load(); v.classList.remove('is-on'); });
      this.jump(this.cur, true);
    }
    showStill(i) {
      var r = this.rooms[i], s = this.still, op = this.pos(r.focus) + ' 50%';
      if (!r.p) return Promise.resolve(null);
      return new Promise(function (res) {
        var img = new Image();
        img.onload = img.onerror = function () { s.classList.remove('is-on'); s.src = r.p; s.style.objectPosition = op; requestAnimationFrame(function () { s.classList.add('is-on'); }); res(null); };
        img.src = r.p;
      });
    }
    show(list, loop, from, to) {
      var self = this;
      if (this.lite) return Promise.resolve(null);
      return new Promise(function (res) {
        var back = self.vids[1 - self.front];
        back.loop = loop; back.preload = 'auto';
        back.style.transition = 'opacity .5s ease';
        back.style.objectPosition = self.pos(from) + ' 50%';
        var k = 0;
        back.onerror = function () { k++; if (k < list.length) { back.src = list[k]; back.load(); } };
        back.src = list[0]; back.load();
        var go = function () {
          back.currentTime = 0;
          var p = back.play(); if (p && p.catch) p.catch(function () {});
          back.classList.add('is-on'); self.vids[self.front].classList.remove('is-on');
          if (self.poster) { self.poster.remove(); self.poster = null; }
          var old = self.vids[self.front]; self.front = 1 - self.front;
          setTimeout(function () { old.pause(); }, 600);
          if (to !== from) {
            var d = (back.duration && isFinite(back.duration)) ? back.duration : 6;
            requestAnimationFrame(function () { requestAnimationFrame(function () {
              back.style.transition = 'opacity .5s ease, object-position ' + d.toFixed(2) + 's cubic-bezier(.45,0,.25,1)';
              back.style.objectPosition = self.pos(to) + ' 50%';
            }); });
          }
          self.focusNow = to;
          res(back);
        };
        if (back.readyState >= 3) go();
        else {
          back.addEventListener('canplay', go, { once: true });
          if (!self.played && (self.dataset.mode || 'auto') === 'auto') {
            setTimeout(function () { if (!self.played) self.goLite(); }, 6000);
          }
        }
        back.addEventListener('playing', function () { self.played = true; }, { once: true });
      });
    }
    reset() {
      if (this.keep) this.keep = false; else this.cap.classList.remove('is-on'); this.black.classList.remove('is-on', 'is-soft');
      this.end.classList.remove('is-on'); this.end.setAttribute('aria-hidden', 'true'); this.foot.style.opacity = 1;
    }
    openEnd() { this.black.classList.add('is-on', 'is-soft'); this.end.classList.add('is-on'); this.end.setAttribute('aria-hidden', 'false'); this.foot.style.opacity = 0; }

    play(i) {
      var self = this, my = ++this.token, r = this.rooms[i];
      var from = i === 0 ? r.focus : this.rooms[i - 1].focus;
      this.cur = i; this.reset(); this.setCopy(i);
      if (this.lite || !r.t.length) { this.jump(i, true); return; }
      this.show(r.t, false, from, r.focus).then(function (v) {
        if (my !== self.token) return;
        if (r.l.length) {
          self.warm(r.l[0]);
          v.addEventListener('ended', function () {
            if (my !== self.token) return;
            self.show(r.l, true, r.focus, r.focus).then(function () { if (my === self.token) { self.cap.classList.add('is-on'); var n = self.rooms[i + 1]; if (n) self.warm(n.t[0]); } });
          }, { once: true });
        } else {
          setTimeout(function () { if (my === self.token) self.cap.classList.add('is-on'); }, 2500);
          var f = function () {
            if (my !== self.token) { v.removeEventListener('timeupdate', f); return; }
            if (v.duration && v.currentTime > v.duration - 1.7) {
              v.removeEventListener('timeupdate', f);
              self.cap.classList.remove('is-on'); self.black.classList.add('is-on');
              setTimeout(function () { if (my === self.token) self.openEnd(); }, 1200);
            }
          };
          v.addEventListener('timeupdate', f);
        }
      });
    }
    jump(i, direct) {
      if (!direct && i === this.cur + 1) { this.play(i); return; }
      var self = this, my = ++this.token, r = this.rooms[i];
      this.cur = i; this.reset(); this.setCopy(i);
      if (this.lite) {
        if (this.poster) { this.poster.remove(); this.poster = null; }
        this.showStill(i).then(function () { if (my === self.token) self.cap.classList.add('is-on'); });
        return;
      }
      if (r.l.length) this.show(r.l, true, r.focus, r.focus).then(function () { if (my === self.token) self.cap.classList.add('is-on'); });
      else if (r.t.length) this.show(r.t, false, r.focus, r.focus).then(function (v) { v.currentTime = Math.max(0, (v.duration || 12) - 4.5); setTimeout(function () { if (my === self.token) self.cap.classList.add('is-on'); }, 600); });
      else this.cap.classList.add('is-on');
    }
  }
  customElements.define('mern-room-film', MernRoomFilm);
})();